import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {RouterLink} from '@angular/router'
import {TopicListItem} from '../../../../../core/content/types/article.types'
import {HolyGrailGridModule} from '../../../../../craft/holy-grail-grid/holy-grail-grid.module'
import {Item} from '../../../../../craft/holy-grail-grid/holy-grail-grid-sidenav/sidenav.types'

@Component({
  selector: 'bgo-sidenav-topics',
  standalone: true,
  imports: [RouterLink, HolyGrailGridModule],
  templateUrl: './sidenav-topics.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: block;
    }
  `,
})
export class SidenavTopicsComponent {
  items: Item[] = []

  @Input() set topics(value: TopicListItem[]) {
    this.items = value.map(t => ({label: t.breadcrumbTitle || t.title, path: t.path}))
  }
}
